'use client';

import { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeftIcon } from '@phosphor-icons/react';
import { useTransactionsInfinite } from '@/hooks/queries/useTransactionsPage';
import { useTransactionsScreenState } from '@/components/transactions/screen/useTransactionsScreenState';
import { adaptTransactionForScreen } from '@/components/transactions/screen/TransactionsScreen';
import { MerchantFrequencyList } from '@/components/transactions/merchants/MerchantFrequencyList';
import { PageHeader } from '@/components/PageHeader';
import { useChatPage } from '@/hooks/useChatPage';

export default function CategoryMerchantsPage() {
  useChatPage('transactions');
  const { categoryId = '' } = useParams<{ categoryId: string }>();
  const state = useTransactionsScreenState();

  const { data: pages, error, isLoading } = useTransactionsInfinite({
    from: state.dateRange.from,
    to: state.dateRange.to,
    parentCategoryId: categoryId,
    limit: 200,
  });

  const transactions = useMemo(() => {
    const raw = pages?.flatMap((p) => p.items) ?? [];
    return raw.map(adaptTransactionForScreen);
  }, [pages]);

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-4 p-4">
      <Link
        to="/transactions"
        className="inline-flex items-center gap-1.5 text-sm font-medium text-text-secondary hover:text-text-primary"
      >
        <ArrowLeftIcon className="size-4" />
        Voltar
      </Link>

      <PageHeader
        title="Comerciantes da categoria"
        description="Ordenados pela frequência de transações no período selecionado."
      />

      {isLoading ? (
        <div className="rounded-xl border border-border bg-surface p-8 text-center text-sm text-text-tertiary">
          Carregando comerciantes…
        </div>
      ) : error ? (
        <div className="rounded-xl border border-border bg-surface p-8 text-center text-sm text-text-tertiary">
          Não foi possível carregar os comerciantes.
        </div>
      ) : (
        <MerchantFrequencyList transactions={transactions} parentCategoryId={categoryId} />
      )}
    </div>
  );
}
